var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1968 3.90009L22.1269 8.77633M22.6496 2.21855L23.7815 3.35054C24.8229 4.39194 24.8229 6.08038 23.7815 7.12178L8.80042 22.1028C8.50768 22.3956 8.15081 22.6161 7.75808 22.7471L2.26536 24.578C1.74419 24.7517 1.24836 24.2559 1.42208 23.7347L3.25299 18.242C3.38391 17.8492 3.60447 17.4924 3.8972 17.1996L18.8783 2.21854C19.9197 1.17715 21.6081 1.17715 22.6496 2.21855Z",
    stroke: "#FEFDFE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.f8e2f05a33935e0284bf8c6c3b491489.svg";
export { ForwardRef as ReactComponent };